var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNewProperty(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_11096_846",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 48,
    height: 48
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_11096_846)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 39.577V18.577L24 8L38 18.577V23.2C37.764 23.136 37.5128 23.0963 37.2465 23.081C36.9805 23.0657 36.7188 23.054 36.4615 23.046V19.346L24 9.904L11.5385 19.3335V38.0385H23.6925C23.7215 38.2932 23.7777 38.5565 23.861 38.8285C23.9447 39.1005 24.0295 39.35 24.1155 39.577H10Z",
    fill: "#9886C2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.6994 40H34.3006V34.6994H29V33.3001H34.3006V28H35.6994V33.3001H41V34.6994H35.6994V40Z",
    fill: "#9886C2"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewProperty);
export default __webpack_public_path__ + "static/media/new_property.a2b6d5fe3eae55866edeaf9ab151cdbf.svg";
export { ForwardRef as ReactComponent };